module.exports = __webpack_public_path__ + "static/media/textLogoColor.18087d83.svg";